import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/executivesummary.css';
import '../styles/FAQ.css';

function executiveSummaryConfidential() {
  return (
    <main className="page main-content executive-summary">
      <center>
        <div className="page-title">Executive Summary</div>
        {/* <div className="page-secondary-title">
          <span className="accent_primary_color_only">Objective:</span> Reduce
          mortality rates for millions of OSA sufferers
        </div> */}
        <div className="page-secondary-title">
          <span className="accent_primary_color_only">Objective: </span>
          {/* Alleviate the suffering for millions of people with obstructive sleep 
          apnea (OSA)*/}
          {/* To restore quality of life for millions impacted by obstructive sleep
          apnea */}
          To help millions sleep better and live longer by treating obstructive
          sleep apnea
        </div>
      </center>
      {/* <hr className="faded" /> */}
      <br />
      <div className="flex-box-container">
        <section className="flex-box-item flex-box-item-1">
          <div>
            <table>
              <tr>
                <td valign="top" className="accent_primary">
                  Problem
                </td>
                <td valign="top">
                  <ul>
                    <li>936 million people worldwide suffer from OSA</li>
                    <li>
                      Untreated OSA is linked to heart disease, stroke,
                      dementia, shortened lifespans, and depression
                    </li>
                    <li>
                      ~65% of those who are prescribed CPAP abandoning the
                      therapy
                      <br />
                      <span className="citation">
                        &nbsp;(
                        <a
                          href="https://pmc.ncbi.nlm.nih.gov/articles/PMC2679572/"
                          className="App-link-color"
                          target="blank"
                        >
                          Can Resp. Journal 2008, Long-term compliance with
                          continuous..
                        </a>
                        )
                      </span>
                      <br />
                      <span className="citation">
                        &nbsp;(
                        <a
                          href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC8745469/"
                          className="App-link-color"
                          target="blank"
                        >
                          J Clin Med. 2022, Factors Affecting Long-Term
                          Compliance of CPAP
                        </a>
                        )
                      </span>
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td colSpan={2}>
                  <span>
                    <hr className="heavily_faded" />
                  </span>
                </td>
              </tr>
              <tr>
                <td valign="top" className="accent_primary">
                  Solution
                </td>
                <td valign="top">
                  <ul>
                    <li>
                      WhisperPT-Ear employs positional therapy (PT) to treat
                      obstructive sleep apnea by using sound cues to encourage
                      side sleeping
                    </li>
                    <li>
                      {/* 56% - 75% of OSA patients have significant reduction of
                      obstructions using PT */}
                      Up to 75% of OSA patients experience significant reduction
                      in apneas using PT
                      <br />
                      <span className="citation">
                        &nbsp;(
                        <a
                          href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC8745469/"
                          className="App-link-color"
                          target="blank"
                        >
                          M. J. L. Ravesloot 2012, The Undervalued potential of
                          positional therapy.
                        </a>
                        )
                      </span>
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td colSpan={2}>
                  <span>
                    <hr className="heavily_faded" />
                  </span>
                </td>
              </tr>
              <tr>
                <td valign="top" className="accent_primary">
                  Market Analysis
                </td>
                <td valign="top">
                  <ul>
                    Market Size
                    <li>
                      $19B by 2032 (TAM) <br />
                      ~200M diagnosed OSA patients
                    </li>
                    <li>
                      $320M (SOM) <br />
                      forecasted revenue over 6 years (bottom-up model)
                      <br />
                      {/* <hr className="heavily_faded" /> */}
                    </li>
                    <br />
                    Competition
                    <li>
                      Competing electronic positional OSA products
                      <ul>
                        <li>
                          <a
                            href="https://www.usa.philips.com/c-e/hs/sleep-apnea-therapy/support/nightbalance.html"
                            className="App-link-color"
                            target="blank"
                          >
                            NightBalance
                          </a>{' '}
                          (Philips) discontinued amid larger FDA compliance
                          issues with CPAP
                        </li>
                        <li>
                          <a
                            href="https://www.advancedbrainmonitoring.com/products/night-shift-sleep-positioner"
                            className="App-link-color"
                            target="blank"
                          >
                            NightShift
                          </a>{' '}
                          - inferior in design, comfort, and technology
                        </li>
                      </ul>
                    </li>
                    <li>
                      Other competitors: Pillows, backpacks, CPAPs, oral
                      devices, and invasive surgeries—all with drawbacks in
                      comfort, usability, or adherence
                    </li>
                    <br />
                    Market Validation <br />
                    2025 Survey of 24 Sleep Specialists
                    <table border="1" className="boxed">
                      <tr>
                        <td>
                          “Once FDA cleared, would you be open to prescribing
                          WhisperPT to your Positional OSA patients?”
                        </td>
                        <td>
                          Yes
                          <br />
                          100%
                        </td>
                      </tr>
                      <tr>
                        <td>
                          “Would you consider prescribing WhisperPT as
                          co-therapy?”
                        </td>
                        <td>
                          Yes
                          <br />
                          100%
                        </td>
                      </tr>
                    </table>
                  </ul>
                </td>
              </tr>
              <br />
              <tr>
                <td colSpan={2}>
                  <span>
                    <hr className="heavily_faded" />
                  </span>
                </td>
              </tr>
              <tr>
                <td colSpan={2}>
                  <span>
                    <hr className="heavily_faded" />
                  </span>
                </td>
              </tr>
              <tr>
                <td valign="top" className="accent_primary">
                  Intellectual Property
                </td>
                <td valign="top">
                  <ul>
                    <li>
                      Foundational Patent Granted
                      <br />
                      <a
                        href="https://patents.google.com/patent/US20230284973A1/en?q=(SleepDev)&oq=SleepDev"
                        target="_blank"
                      >
                        (US20230284973A1)
                      </a>
                    </li>
                    <li>Four additonal patents in process</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td colSpan={2}>
                  <span>
                    <hr className="heavily_faded" />
                  </span>
                </td>
              </tr>
              <tr>
                <td valign="top" className="accent_primary">
                  Regulatory
                </td>
                <td valign="top">
                  <ul>
                    <li>Q1/Q2 2026 N=30 Clinical Study</li>
                    <li>NSR Class II device with clear 510(k) predicate.</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td colSpan={2}>
                  <span>
                    <hr className="heavily_faded" />
                  </span>
                </td>
              </tr>
              <tr>
                <td valign="top" className="accent_primary">
                  Reimbursement
                </td>
                <td valign="top">
                  <ul>
                    <li>Covered under HCPCS code E0530</li>
                    <li>Up to $482.56 / unit</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td colSpan={2}>
                  <span>
                    <hr className="heavily_faded" />
                  </span>
                </td>
              </tr>
              <tr>
                <td valign="top" className="accent_primary">
                  Team
                </td>
                <td valign="top">
                  <ul>
                    Execution and Leadership
                    <li>
                      <a
                        href="https://www.linkedin.com/in/swertfager/"
                        target="blank"
                      >
                        <span className="App-link-color">
                          Michael Swertfager:
                        </span>
                      </a>
                      &nbsp; CEO &amp; co-founder
                      <br />
                      30 years driving multi-million dollar programs at Cisco,
                      Symantec, and Apple
                    </li>
                    <li>
                      <a
                        href="https://www.linkedin.com/in/jamesgartrell/"
                        target="blank"
                      >
                        <span className="App-link-color">James Gartrell:</span>
                      </a>
                      &nbsp; CTO &amp; co-founder
                      <br />
                      35 year operations leader optimizing business process and
                      engineering at Apple, Riot, and Zynga
                    </li>
                    <br />
                    Sleep Medicine
                    <li>
                      <a
                        href="https://www.linkedin.com/in/sleepdoctorroland/"
                        target="blank"
                      >
                        <span className="App-link-color">
                          Joshua Roland, MD:
                        </span>
                      </a>
                      &nbsp; Chief Medical Officer (CMO) <br />
                      Doctor of Sleep Medicine; Sanusom; UCLA; Emory University
                    </li>
                    <li>
                      <a
                        href="https://www.linkedin.com/in/loganschneider/"
                        target="blank"
                      >
                        <span className="App-link-color">
                          Logan Schneider, MD:
                        </span>
                      </a>
                      &nbsp;Sleep Medicine & Neurologist, Johns Hopkins;
                      Stanford
                    </li>
                    <li>
                      <a
                        href="https://sleep.hms.harvard.edu/faculty-staff/david-p-white"
                        target="blank"
                      >
                        <span className="App-link-color">
                          David P. White, MD:
                        </span>
                        &nbsp;Chief Scientific Advisor; Physician Sleep
                        Medicine; Harvard
                      </a>
                    </li>
                    <br />
                    Regulatory
                    <li>
                      <a
                        href="https://www.linkedin.com/in/danielcher/"
                        target="blank"
                      >
                        <span className="App-link-color">Daniel Cher, MD:</span>
                      </a>
                      &nbsp; Chief Regulatory Officer (CRO)
                      <br />
                      Sr. VP of Clinical & Regulatory Affairs at SI-BONE;
                      Stanford; Yale
                    </li>
                  </ul>
                </td>
              </tr>
            </table>
          </div>
        </section>
        {/* Source 3*/}
        <section className="flex-box-margin-only">
          <table>
            <tr>
              <td valign="top">
                WhisperPT-Ear
                <br />
                Minimum Viable Product with 1300+ nights of testing
                <div className="boxed">
                  <div className="image-padding">
                    <center>
                      <img
                        className="hero-image"
                        src="/images/product/WPT-Ear_V3_in_ear_close-up_and_measurement2.jpg"
                        alt="WPT-Ear_V3"
                        width="300px"
                      />
                    </center>
                  </div>
                </div>
              </td>
            </tr>
            <br />
            <tr>
              <td>
                Integrated Interface
                <div className="boxed">
                  <div className="image-padding">
                    <center>
                      <img
                        className="hero-image"
                        // src="/images/product/App_Screen_Shots.jpg"
                        src="/images/product/App_Configure_and_Summary4.jpg"
                        alt="WPT-PAP Low Profile and High Fidelity"
                        width="300px"
                      />
                      <br />
                    </center>
                  </div>
                </div>
              </td>
            </tr>
            <br />
            {/* <div className="accent_primary">Testimonials</div> */}
            <br />
            <div className="narrow-quote-block">
              "This technology is a game changer. The device is a great
              alternative to traditional sleep apnea treatments."
              <br />
              <span className="accent_standard">
                Dr. Anil Rama
                <br />
                Sleep Medicine - Stanford
              </span>
            </div>
            <br />
            <div className="narrow-quote-block">
              "I expect the future of OSA management to focus on positional
              therapy."
              <br />
              <span className="accent_standard">
                Dr. Bryan Chessen
                <br /> Sleep Medicine - NYC Health
              </span>
            </div>
            <br />
            <div className="narrow-quote-block">
              "Sold. When can I prescribe this?"
              <br />
              <span className="accent_standard">
                Dr. Sam Kashani
                <br /> Sleep Medicine - UCLA
              </span>
            </div>
          </table>
        </section>
      </div>
      <div>
        <hr className="heavily_faded" />
      </div>
      <br />
      <center>
        {/* <div className="align-left"> */}
        <div className="sdevice-section">
          <table className="bottom">
            {/* <tr>
              <td cellPadding="20px">
                <div className="">Additional Resources:</div>
                <ul>
                  <li>
                    <a
                      href="/docs/SleepDev_PitchDeck.pdf"
                      className="App-link-color"
                      target="blank"
                    >
                      SleepDev pitch deck
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://vimeo.com/manage/videos/958224879"
                      className="App-link-color"
                      target="blank"
                    >
                      Recorded SleepDev short pitch (6 mins)
                    </a>
                  </li>
                </ul>
              </td>
            </tr>*/}
            <tr>
              <td>
                {' '}
                <div>
                  Strategic partners and investors can engage Michael
                  Swertfager, CEO & co-founder, at:
                  <br />
                </div>
                <a
                  href="mailto:michael@SleepDev.com"
                  className="App-link-color"
                >
                  <span className="App-link-color">michael@SleepDev.com</span>
                </a>
                &nbsp; / &nbsp; (408)-499-6884 /
                <a
                  href="https://calendly.com/mswertfager-sleepdev"
                  className="App-link-color"
                  target="_blank"
                >
                  {' '}
                  quick discussion - calendly
                </a>
              </td>
            </tr>
            {/* <tr>
              <td>SleepDev is a registered Delaware C Corporation </td>
            </tr> */}
          </table>
        </div>
      </center>
    </main>
  );
}
export default executiveSummaryConfidential;
